import { OnlineOfflineStatusType } from '../online-offline/online-offline.model';

export type SockServerEvent = SubMessageEvent | SockMessageServerEvent;

export interface SubMessageEvent {
  channel: 'subscribe';
  body: 'OK';
}

interface WebsocketProjectData {
  address?: string;
  appended_descr: string;
  currency?: string;
  currencyCode: string;
  exchangerate: string;
  featured: boolean;
  free_bid_until?: number;
  fulltime: boolean;
  hideBids: boolean;
  id: number;
  imgUrl: string;
  isLocal: boolean;
  isMinimallyPostedProject: boolean;
  isTest: boolean;
  jobs: string[];
  jobString: string;
  linkUrl: string;
  maxbudget?: number;
  minbudget?: number;
  minimallyPostedProjectBudgetSet: boolean;
  nonpublic: boolean;
  projIsHourly: boolean;
  publicName?: string;
  showBudgetMinimallyPostedProject: boolean;
  submitDate: string;
  text: string;
  time: number;
  title: string;
  userId: number;
  userName: string;
}
export interface WebsocketAwardEvent {
  type: 'award';
  data: {
    acceptByTime?: number;
    actionText?: string;
    apiMessage?: {
      bid: {
        amount: number;
        award_status: 'pending';
        bidder_id: number;
        id: number;
        period: number;
      };
      project: {
        currency: { code: string; sign: string };
        id: number;
        owner_id: number;
        title: string;
        type: 'fixed';
      };
      users: { [id: string]: { username: string } };
    };
    appended_descr?: string;
    awardeeId?: number;
    awardeeName?: string;
    bid?: {
      bidAmount: string;
      bidDescr: null;
      bidId: number;
      bidPeriod: string;
      id: number;
      submitTime: number;
    };
    categoryName?: string;
    currencycode?: string;
    currencysign?: string;
    id: number;
    imgUrl?: string;
    isTest?: boolean;
    jobs: string[];
    jobString: string;
    linkUrl?: string;
    projIsHourly?: boolean;
    text?: string;
    time?: number;
    title: string;
    userId: number;
    userName: string;
  };
}

export interface WebsocketAwardBadgeEvent {
  type: 'awardBadge';
  data: {
    descr: string;
    id: number;
    name: string;
  };
}

export interface WebsocketAwardCreditEvent {
  type: 'awardCredit';
  data: {
    amount: string; // I think?
  };
}

export interface WebsocketAwardReminderEvent {
  type: 'awardReminder';
  data: {
    name: string;
    userName: string;
  };
}

export interface WebsocketAwardMilestoneReminderEvent {
  type: 'awardMilestoneReminder';
  data: {
    publicName?: string;
    userName: string;
  };
}

export interface WebsocketAwardXpEvent {
  type: 'awardXp';
  data: {
    amount: string; // I think?
    descr: string;
  };
}

interface WebsocketBidEventProjectCount {
  all: number;
  incomplete_reviews: number;
  complete: number;
  completion_rate: number;
  reviews: number;
  earnings: number;
  incomplete: number;
}

interface WebsocketBidEventReputation {
  com: number;
  exp: number;
  hag: number;
  onb: number;
  ont: number;
  overall: number;
  pos: number;
  pro: number;
  qua: number;
}

interface WebsocketBidEventSellerRating {
  count: number;
  projectCount: {
    last12months: WebsocketBidEventProjectCount;
    last3months: WebsocketBidEventProjectCount;
    entire_history: WebsocketBidEventProjectCount;
  };
  completionRate: number;
  avg: number;
  reputation: {
    last12months: WebsocketBidEventReputation;
    last3months: WebsocketBidEventReputation;
    entire_history: WebsocketBidEventReputation;
  };
}
export interface WebsocketBidEvent {
  type: 'bid';
  data: {
    accountId?: number;
    amount: string;
    award?: string;
    bidAvg?: string;
    bidCount?: number;
    bidHidden: boolean;
    bidNo?: string;
    buyerFeePerDollar?: string;
    buyerMinProjectFee?: string;
    categoryName?: string;
    currency: string;
    currencyCode: string;
    currencyId: string;
    descr: string;
    id: number;
    imgUrl: string;
    initMilestone?: number;
    linkUrl?: string;
    period: string;
    pmb: undefined;
    projectId: string;
    projIsFullTime: boolean;
    projIsHourly: boolean;
    projName: string;
    publicName?: string;
    showAwardFee: boolean;
    text?: string;
    time: number;
    title: string;
    userId: string;
    userName: string;
    userBalances?: {
      all: {
        currency: {
          code: string;
          country: string;
          exchangerate: string;
          id: string;
          is_external?: string;
          name: string;
          seq: string;
          sign: string;
        };
        balance: string;
      }[];
      relevant: number;
    };
    bid: {
      award_score?: number;
      completed?: boolean;
      completion_score?: number;
      descr_html?: string;
      descr_short_html?: string;
      descr_short?: string;
      descr?: null;
      expert_guarantee?: null;
      highlighted?: boolean;
      id?: number;
      isShortlisted?: null;
      milestone_percentage?: string;
      new_ranking?: number;
      no?: string;
      paid_status?: null;
      period?: string;
      project_id?: string;
      r2?: number;
      ranking?: number;
      score?: number;
      sponsored?: null;
      submitdate_f?: string;
      submitdate_f2?: ' recently';
      submitdate_ts?: number;
      submitdate?: string;
      sum?: string;
      users_id?: number;
      user?: {
        address: { country: string; code: string; city: null };
        company: string;
        currency: number;
        earnings: number;
        flag_class: string;
        flag_name: string;
        flag: { name: string; icon: string };
        gold: number;
        hourlyrate: number;
        id: number;
        insignia: {
          name: string;
          title: string;
          examEnabled: string;
          examId: string;
          id: string;
          description: string;
        }[];
        isPortfolioCreated: boolean;
        jobs: string[];
        logo_Url: string;
        normalMemberclassLogo: string;
        online?: string;
        profile_logo_Url: string;
        provider_rating: { count: number; avg: string };
        publicName?: string;
        rating: { count: number; avg: string };
        reg_date: string;
        reg_unixtime: number;
        reputation_rate: number;
        timezone: number;
        tooltipMemberclassLogo: string;
        Url: string;
        username: string;
        seller_rating: WebsocketBidEventSellerRating;
      };
    };
  };
}

export interface WebsocketCompletedEvent {
  type: 'completed';
  data: {
    name: string;
    state?: 'completed'; // I think
    userName: string;
  };
}

export interface WebsocketContactRequestReceivedEvent {
  type: 'contactRequestReceived';
  data: {
    pendingAjax: boolean;
    request: { state: 'accepted' | 'pending' | 'rejected' };
    user: { username: string };
  };
}

export interface WebsocketContestEvent {
  type: 'contest';
  data: {
    buyer?: string;
    buyerUrl?: string;
    currency?: string;
    currencyCode: string;
    exchangerate: string;
    extended: boolean;
    featured: boolean;
    free_bid_until?: number;
    highlight: undefined;
    id: string;
    imgUrl: string;
    isTest: boolean;
    jobs: number[];
    jobString: string;
    linkUrl: string;
    locked: boolean;
    maxbudget?: string; // I think?
    private: boolean;
    sealed: boolean;
    submitDate: string;
    time: number;
    title: string;
    userId: string;
    userName: string;
  };
}

export interface WebsocketContestAwardedToEmployerEvent {
  type: 'contestAwardedToEmployer';
  data: {
    contestName: string;
    contestSEOUrl: string;
    currencyCode: string;
    currencySign: string;
    entry_id: string;
    entry_number: string;
    entryCount: string;
    freelancerCount: string;
    imgUrl: string;
    isBought: boolean;
    linkUrl: string;
    prize: string;
    thumb: string;
    time: number;
    userId: number;
    userName: string;
  };
}

export interface WebsocketContestAwardedToFreelancerEvent {
  type: 'contestAwardedToFreelancer';
  data: {
    contestName: string;
    entry_number: string; // I think?
  };
}

export interface WebsocketContestEntryBoughtToEmployerEvent {
  type: 'contestEntryBoughtToEmployer';
  data: {
    contestName: string;
    entry_number: string; // I think?
    publicName?: string;
    userName: string;
  };
}

export interface WebsocketContestEntryBoughtToFreelancerEvent {
  type: 'contestEntryBoughtToFreelancer';
  data: {
    contestName: string;
    entry_number: string; // I think?
  };
}

export interface WebsocketContestEntryEvent {
  type: 'contestEntry';
  data: {
    contestHolder: string;
    contestId: string;
    contestName: string;
    firstUser?: string;
    firstUserPublicName?: string;
    id: string;
    imgUrl: string;
    linkUrl: string;
    secondUser?: string;
    secondUserPublicName?: string;
    time: number;
    userId: number;
  };
}

export interface WebsocketContestPCBNotificationEvent {
  type: 'contestPCBNotification';
  data: {
    contestHolder: string;
    contestId: string;
    contestName: string;
    firstUser?: string;
    firstUserPublicName?: string;
    id: string;
    imgUrl: string;
    linkUrl: string;
    secondUser?: string;
    secondUserPublicName?: string;
    time: number;
    userId: number;
  };
}

export interface WebsocketContestPCBNotificationFullViewEvent {
  type: 'contestPCBNotificationFullView';
  data: {
    contestName: string;
    entryNumber: string; // I think?
    firstUser: string;
    firstUserPublicName?: string;
    secondUser?: string;
    secondUserPublicName?: string;
  };
}

export interface WebsocketCreateMilestoneEvent {
  type: 'createMilestone';
  data: {
    amount: string; // I think?
    currencycode: string;
    currencysign: string;
    publicName?: string;
    title: string;
    userName: string;
  };
}

export interface WebsocketDenyedEvent {
  type: 'denyed';
  data: {
    publicName?: string;
    userName: string;
    name: string;
  };
}

export interface WebsocketDraftContestEvent {
  type: 'draftContest';
  data: {
    contestEditUrl?: string;
    contestId: string;
    contestName: string;
    contestUrl: string;
    imgUrl: string;
    isPublished: boolean;
    time: number;
  };
}

export interface WebsocketFailingProjectEvent {
  type: 'failingProject';
  data: WebsocketProjectData & {
    projectFreeBid: boolean;
    xpValue: number;
  };
}

export interface WebsocketHighLtvAnnualDiscountEvent {
  type: 'highLtvAnnualDiscount';
  data: {
    userDisplayName: string;
  };
}

export interface WebsocketInviteUserBidEvent {
  type: 'inviteUserBid';
  data: {
    jobString: string;
    publicName?: string;
    title: string;
    userName: string;
  };
}

export interface WebsocketInviteToContestEvent {
  type: 'inviteToContest';
  data: {
    buyerName: string;
    buyerPublicName?: string;
    currencycode: string;
    currencysign: string;
    prize: string; // I think?
    title: string;
  };
}

export interface WebsocketInvoiceRequestedEvent {
  type: 'invoiceRequested';
  data: {
    amount: string; // I think?
    currencyCode: string;
    currencySign: string;
    name: string;
    publicName?: string;
    state?: 'paid'; // I think?
    userName: string;
  };
}

export interface WebsocketLevelupEvent {
  type: 'levelup';
  data: {
    level: string; // I think?
    membership: boolean;
    perks: {
      description: string;
      item: boolean;
      magnitude: number;
      name?: 'BidRefreshRate' | 'item';
      symbol: string;
    }[];
    username: string;
  };
}

export interface WebsocketNotifyfollowerEvent {
  type: 'notifyfollower';
  data: {
    jobString: string;
    title: string;
    userName: string;
  };
}

export interface WebsocketProjectRecruiterEvent {
  type: 'projectRecruiter';
  data: {
    agent: { username: string };
    message: string;
    project: { name: string };
  };
}

export interface WebsocketProjectEvent {
  type: 'project';
  data: WebsocketProjectData;
}

export interface WebsocketQuickHireProjectEvent {
  type: 'quickHireProject';
  data: {
    currency?: { code: string; sign: string };
    jobString: string;
    period?: number;
    projIsHourly: boolean;
    sum?: string; // I think?
    title: string;
    userName: string;
  };
}

export interface WebsocketReleaseMilestoneEvent {
  type: 'releaseMilestone';
  data: {
    amount: string; // I think?
    currencycode: string;
    currencysign: string;
    publicName?: string;
    title: string;
    userName: string;
  };
}

export interface WebsocketRequestEndProjectEvent {
  type: 'requestEndProject';
  data: {
    dayCount?: string; // I think?
    publicName?: string;
    title: string;
    userName: string;
  };
}

export interface WebsocketRequestMilestoneEvent {
  type: 'requestMilestone';
  data: {
    amount: string; // I think?
    currencyCode: string;
    currencySign: string;
    name: string;
    publicName?: string;
    state?: 'accept'; // I think?
    userName: string;
  };
}

export interface WebsocketRequestToReleaseEvent {
  type: 'requestToRelease';
  data: {
    amount: string; // I think?
    currencycode: string;
    currencysign: string;
    name: string;
    publicName?: string;
    state?: 'accept'; // I think?
    userName: string;
  };
}

export interface WebsocketServiceApprovedEvent {
  type: 'serviceApproved';
  data: {
    service_name: string;
  };
}

export interface WebsocketServiceProjectEndingSellerEvent {
  type: 'serviceProjectEndingSeller';
  data: {
    buyer_name: string;
    hours_remaining?: number;
    order_start_date: string;
    service_name: string;
  };
}

export interface WebsocketServiceProjectPostedSellerEvent {
  type: 'serviceProjectPostedSeller';
  data: {
    buyer_name: string;
    buyer_public_name?: string;
    service_name: string;
  };
}

export interface WebsocketServiceRejectedEvent {
  type: 'serviceRejected';
  data: {
    service_name: string;
  };
}

export interface WebsocketSignUpFreeTrialUpsellEvent {
  type: 'signUpFreeTrialUpsell';
  data: {
    trialPackageName: string;
  };
}

export interface WebsocketSitesBinCreatedEvent {
  type: 'sitesBinCreated';
  data: {
    bid: { bidder: { username: string } };
    listing: { url: string };
  };
}

export interface WebsocketSitesHandOverMessageSentEvent {
  type: 'sitesHandOverMessageSent';
  data: {
    listing: { url: string };
    sender: { username: string };
  };
}

export interface WebsocketSitesListingStatusChangedEvent {
  type: 'sitesListingStatusChanged';
  data: {
    listing:
      | { status: 'activated'; url: string }
      | { status: 'bin_rejected'; url: string }
      | { status: 'closed_bidder'; url: string }
      | { status: 'closed'; url: string }
      | { status: 'closing_bidder'; url: string }
      | { status: 'closing'; url: string }
      | { status: 'completed_bidder'; url: string }
      | { status: 'completed'; url: string }
      | { status: 'draft'; url: string }
      | { status: 'feedback_reminder_bidder'; url: string }
      | { status: 'feedback_reminder'; url: string }
      | {
          status: 'funds_released_bidder';
          fmt_price: string;
          seller_name: string;
          url: string;
        }
      | {
          status: 'funds_released';
          bidder_name: string;
          fmt_price: string;
          url: string;
        }
      | { status: 'outbid'; url: string }
      | { status: 'reserve_achieved_bidder'; url: string }
      | { status: 'reserve_achieved'; url: string };
  };
}

export interface WebsocketSitesMessageSentEvent {
  type: 'sitesMessageSent';
  data: {
    listing: { url: string };
    sender: { username: string };
  };
}

export interface WebsocketSitesOfferCreatedEvent {
  type: 'sitesOfferCreated';
  data: {
    bid: { bidder: { username: string } };
    listing: { url: string };
  };
}

export interface WebsocketUpsellCrowdsourceFindingEvent {
  type: 'upsellCrowdsourceFinding';
  data: {
    project_name: string;
  };
}

export interface WebsocketXpContestEvent {
  type: 'xpContest';
  data: {
    currency?: string;
    jobString: string;
    maxbudget?: number;
    title: string;
    userName: string;
  };
}

type WebsocketStandardBaseEvent =
  | WebsocketAwardEvent
  | WebsocketAwardBadgeEvent
  | WebsocketAwardCreditEvent
  | WebsocketAwardMilestoneReminderEvent
  | WebsocketAwardReminderEvent
  | WebsocketAwardXpEvent
  | WebsocketBidEvent
  | WebsocketCompletedEvent
  | WebsocketContactRequestReceivedEvent
  | WebsocketContestEvent
  | WebsocketContestAwardedToEmployerEvent
  | WebsocketContestAwardedToFreelancerEvent
  | WebsocketContestEntryEvent
  | WebsocketContestEntryBoughtToEmployerEvent
  | WebsocketContestEntryBoughtToFreelancerEvent
  | WebsocketContestPCBNotificationEvent
  | WebsocketContestPCBNotificationFullViewEvent
  | WebsocketCreateMilestoneEvent
  | WebsocketDenyedEvent
  | WebsocketDraftContestEvent
  | WebsocketFailingProjectEvent
  | WebsocketHighLtvAnnualDiscountEvent
  | WebsocketInviteToContestEvent
  | WebsocketInviteUserBidEvent
  | WebsocketInvoiceRequestedEvent
  | WebsocketLevelupEvent
  | WebsocketNotifyfollowerEvent
  | WebsocketProjectEvent
  | WebsocketProjectRecruiterEvent
  | WebsocketQuickHireProjectEvent
  | WebsocketReleaseMilestoneEvent
  | WebsocketRequestEndProjectEvent
  | WebsocketRequestMilestoneEvent
  | WebsocketRequestToReleaseEvent
  | WebsocketServiceApprovedEvent
  | WebsocketServiceProjectEndingSellerEvent
  | WebsocketServiceProjectPostedSellerEvent
  | WebsocketServiceRejectedEvent
  | WebsocketSignUpFreeTrialUpsellEvent
  | WebsocketSitesBinCreatedEvent
  | WebsocketSitesHandOverMessageSentEvent
  | WebsocketSitesListingStatusChangedEvent
  | WebsocketSitesMessageSentEvent
  | WebsocketSitesOfferCreatedEvent
  | WebsocketUpsellCrowdsourceFindingEvent
  | WebsocketXpContestEvent;

interface BaseServerEvent {
  channel: 'user';
  body: {
    aggregated: null;
    display: boolean;
    id: string;
    is_important: boolean;
    is_notification: boolean;
    is_project: boolean;
    message: string;
    news_feed: boolean;
    no_persist: boolean;
    popup: boolean;
    targets: any[];
    timestamp: number;
  };
}
type SockMessageStandardServerEvent = BaseServerEvent & {
  body: {
    parent_type: 'notifications';
  } & WebsocketStandardBaseEvent;
};

type CustomServerEvent<Type, Data, ParentType> = BaseServerEvent & {
  body: {
    data: Data;
    parent_type: ParentType;
    type: Type;
  };
};

interface OnlineOfflineData { [userId: string]: OnlineOfflineStatusType }

export type OnlineOfflineEvent = CustomServerEvent<
  'statusget',
  OnlineOfflineData,
  'onlineoffline'
>;

export type WebsocketBaseEvent =
  | WebsocketStandardBaseEvent
  | { type: 'onlineOffline'; data: OnlineOfflineData };

export type SockMessageServerEvent =
  | SockMessageStandardServerEvent
  | OnlineOfflineEvent;

export function isOnlineOfflineEvent(
  event: SockMessageServerEvent,
): event is OnlineOfflineEvent {
  return (
    event.channel === 'user' &&
    event.body &&
    event.body.parent_type === 'onlineoffline'
  );
}

export function isSockMessageServerEvent(
  event: SockServerEvent,
): event is SockMessageServerEvent {
  return event.channel === 'user';
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/websocket/server-message-event.model.ts